
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iNYtG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4r9Ir = parcelRequire("4r9Ir");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $l5y3Y = parcelRequire("l5y3Y");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $804Ue = parcelRequire("804Ue");


var $83eLG = parcelRequire("83eLG");


var $aM1he = parcelRequire("aM1he");

const $d9d12cfcf38f06b2$export$ae25147d30bdeffa = ({ contentId: contentId, contentType: contentType })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const { addNewComment: addNewComment, removeComment: removeComment, clearNewComments: clearNewComments } = (0, $cozmU.useContext)((0, $4r9Ir.NewCommentsContext));
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $cozmU.useRef)([]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: contentId
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { getCurrentCommentsPanelState: getCurrentCommentsPanelState, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment } = (0, $8i27m.useCommentsDataActions)();
    const { setReplyToCommentId: setReplyToCommentId, getCommentsPanelState: getCommentsPanelState } = (0, $3mVfX.useCommentsPanelActions)();
    const clearReplyIfRemoved = (0, $cozmU.useCallback)(({ commentId: commentId })=>{
        const { replyToCommentId: replyToCommentId } = getCommentsPanelState();
        if (replyToCommentId === commentId) setReplyToCommentId();
    }, [
        getCommentsPanelState,
        setReplyToCommentId
    ]);
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // The missed-events reload path below is dead: it only runs when MissedPubSubCommentEventsHandler
    // fires onEventFetchSuccess, which no longer happens now that cc_fps_migration_comments and
    // confluence_enable_subscriptions-context-provider are permanently enabled (those gates early-return
    // all of MissedPubSubCommentEventsHandler's effects). This no-op reloader is a placeholder to
    // preserve the (unreachable) reloader signature.
    // TODO: This began being flagged by oxlint as part of a feature-gate cleanup PR; investigate separately.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
    const activeCommentsRefetch = ()=>Promise.resolve();
    const subscribeToPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - do not setup pubsub for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length > 0) return;
        const queryArgs = {
            isReactionsEnabled: isReactionsEnabled
        };
        subscriptions.current = (0, $83eLG.setUpPageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            getCurrentCommentsPanelState: getCurrentCommentsPanelState,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            clearReplyIfRemoved: clearReplyIfRemoved
        }) ?? [];
    }, [
        contentId,
        contentType,
        userId,
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        updateRemovedCommentIdsMap,
        reopenParentComment,
        getCurrentCommentsPanelState,
        addSubscriber,
        setContentType,
        setContentId,
        updateUnreadCommentIDSet,
        getViewedCommentsCacheOnly,
        addCommentInCache,
        deleteCommentInCache,
        pageMode,
        clearReplyIfRemoved
    ]);
    const unsubscribeFromPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - no pubsub was set up for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length === 0) return;
        const queryArgs = {
            isReactionsEnabled: isReactionsEnabled
        };
        (0, $83eLG.removePageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        });
        subscriptions.current = [];
    }, [
        contentId,
        contentType,
        userId,
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        updateRemovedCommentIdsMap,
        removeSubscriber,
        getViewedCommentsCacheOnly,
        pageMode
    ]);
    const handleEventFetchSuccess = (0, $cozmU.useCallback)((data)=>{
        if (data && data.contentId === contentId) {
            if (data.commentEvents.length) {
                const commentData = data.commentEvents.map((event)=>{
                    return {
                        commentId: event.id,
                        accountId: event.accountId
                    };
                });
                (0, $aM1he.reloadAndAddPageComments)(activeCommentsRefetch, addNewComment, commentData, userId);
            }
        }
    }, [
        contentId,
        addNewComment,
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
        activeCommentsRefetch,
        userId
    ]);
    if (!userId || pageMode === (0, $cD1qu.PageMode).EDIT && (0, $6mKj3.expValEquals)('confluence_comments_get_document_version_number', 'isEnabled', true)) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).FOOTER,
        subscribeToPubSubEvents: subscribeToPageCommentsPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPageCommentsPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onDocumentReturn: clearNewComments,
        isAutoReloadPageComments: true
    }));
};
module.exports["PageCommentsPubSubHandler"] = $d9d12cfcf38f06b2$export$ae25147d30bdeffa;

});

parcelRegister("83eLG", function(module, exports) {

var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $e4kZB = parcelRequire("e4kZB");


var $lb2Lp = parcelRequire("lb2Lp");


var $hfNnW = parcelRequire("hfNnW");


var $b11gn = parcelRequire("b11gn");

const $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS = [
    500,
    1000,
    2000
];
/**
 * Fetches a comment by ID with automatic retry on null result.
 * The pubsub event can arrive before the server has committed the comment,
 * causing fetchCommentById to return null. We retry with backoff to handle this.
 */ const $ced40be9017d58cb$var$fetchCommentByIdWithRetry = async ({ commentId: commentId, contentId: contentId })=>{
    let result = await (0, $lb2Lp.fetchCommentById)({
        commentId: commentId,
        contentId: contentId,
        fetchPolicy: 'network-only'
    });
    if (result !== null) return result;
    for (const delayMs of $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS){
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve)=>setTimeout(resolve, delayMs));
        // eslint-disable-next-line no-await-in-loop
        result = await (0, $lb2Lp.fetchCommentById)({
            commentId: commentId,
            contentId: contentId,
            fetchPolicy: 'network-only'
        });
        if (result !== null) return result;
    }
    return result;
};
const $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment = ({ comment: comment, userId: userId, viewedComments: viewedComments, updateUnreadCommentIDSet: updateUnreadCommentIDSet })=>{
    const validUnreadCommentIds = new Set();
    // Validate the main comment
    const commentForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
        commentId: comment.id,
        userId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined,
        createdAt: comment.createdAt?.value || undefined,
        commentType: 'FOOTER',
        // Page comments are always FOOTER type
        resolveProperties: {
            resolved: false
        } // reopened comment = resolved false
    });
    if ((0, $e4kZB.isValidUnreadComment)({
        comment: commentForValidation,
        currentUserId: userId,
        viewedComments: viewedComments
    })) validUnreadCommentIds.add(comment.id);
    // Validate replies if they exist
    if (comment.replies) comment.replies.forEach((reply)=>{
        const replyForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
            commentId: reply.id,
            userId: reply.author?.__typename === 'KnownUser' ? reply.author.accountId : undefined,
            createdAt: reply.createdAt?.value || undefined,
            commentType: 'FOOTER',
            // Page comments are always FOOTER type
            resolveProperties: {
                resolved: false
            } // reopened comment = resolved false
        });
        if ((0, $e4kZB.isValidUnreadComment)({
            comment: replyForValidation,
            currentUserId: userId,
            viewedComments: viewedComments
        })) validUnreadCommentIds.add(reply.id);
    });
    updateUnreadCommentIDSet(validUnreadCommentIds, 'add');
};
const $ced40be9017d58cb$export$4d067148c1e8c84d = ({ userId: userId, contentId: contentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>(event, payload)=>{
        if (!event) return;
        let commentRequestBody;
        const { accountId: accountId, originTabId: originTabId } = payload;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) commentRequestBody = payload?.[event];
        else commentRequestBody = payload.commentRequestBody;
        const { commentId: commentId } = commentRequestBody;
        if ((0, $hfNnW.shouldSkipOwnPubSubEvent)({
            accountId: accountId,
            currentUserId: userId,
            originTabId: originTabId
        })) return;
        const { start: startCommentsPubSubExperience, fail: failCommentsPubSubExperience, handleCompletePubSubExperiences: handleCompletePubSubExperiences } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).PageCommentsPubSub, commentId);
        startCommentsPubSubExperience(event);
        try {
            switch(event){
                case 'commentCreated':
                case 'avi:confluence:created:comment':
                    if (addCommentInCache && commentId) {
                        const fetchFn = (0, $6mKj3.expVal)('cc_comments_page_comment_retry', 'isEnabled', false) ? $ced40be9017d58cb$var$fetchCommentByIdWithRetry : ({ commentId: cId, contentId: cntId })=>(0, $lb2Lp.fetchCommentById)({
                                commentId: cId,
                                contentId: cntId,
                                fetchPolicy: 'network-only'
                            });
                        fetchFn({
                            commentId: commentId,
                            contentId: contentId
                        }).then((comment)=>{
                            if (comment) {
                                addCommentInCache({
                                    newComment: comment,
                                    onError: failCommentsPubSubExperience
                                });
                                return handleCompletePubSubExperiences();
                            } else failCommentsPubSubExperience(new Error(`commentCreated: comment ${commentId} not found after retries`));
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                    } else failCommentsPubSubExperience(new Error('commentCreated: addCommentInCache or commentId is not defined'));
                    if (updateUnreadCommentIDSet && accountId !== userId) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                    break;
                case 'commentResolved':
                case 'avi:confluence:resolved:comment':
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }).then((comment)=>{
                        clearReplyIfRemoved?.({
                            commentId: commentId
                        });
                        // Handle unread comments after fetchCommentById completes
                        const { replies: replies = [] } = commentRequestBody;
                        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                            commentId,
                            ...replies
                        ]), 'remove');
                        return handleCompletePubSubExperiences([
                            {
                                comment: comment,
                                type: (0, $b11gn.CommentsPubsubTrackedEventType).Resolve
                            }
                        ]);
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentResolved: commentId is not defined'));
                    // Only commentActionType and commentId are used; the rest of the variables here are defaults
                    if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                        threadKey: commentId,
                        commentId: commentId,
                        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                        isReply: false,
                        commentType: (0, $kgNLQ.CommentType).GENERAL
                    });
                    break;
                case 'commentDeleted':
                case 'avi:confluence:deleted:comment':
                    if (deleteCommentInCache && commentId) {
                        const deletionSuccessful = deleteCommentInCache({
                            commentId: commentId,
                            onError: failCommentsPubSubExperience
                        });
                        if (deletionSuccessful) clearReplyIfRemoved?.({
                            commentId: commentId
                        });
                    }
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'remove');
                    // Only commentActionType and commentId are used; the rest of the variables here are defaults
                    if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                        threadKey: commentId,
                        commentId: commentId,
                        commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        isReply: false,
                        commentType: (0, $kgNLQ.CommentType).GENERAL
                    });
                    handleCompletePubSubExperiences().catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    break;
                case 'commentReopened':
                case 'avi:confluence:reopen:comment':
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }).then((commentData)=>{
                        // Handle unread comments with the fetched comment data
                        if (updateUnreadCommentIDSet && commentData && userId && getViewedCommentsCacheOnly) {
                            const viewedCommentsResult = getViewedCommentsCacheOnly();
                            if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                comment: commentData,
                                userId: userId,
                                viewedComments: viewedCommentsResult.data,
                                updateUnreadCommentIDSet: updateUnreadCommentIDSet
                            });
                        }
                        return handleCompletePubSubExperiences([
                            {
                                comment: commentData,
                                type: (0, $b11gn.CommentsPubsubTrackedEventType).Reopen
                            }
                        ]);
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentReopened: commentId is not defined'));
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (commentId && reopenParentComment) reopenParentComment({
                        threadKey: commentId,
                        commentType: (0, $kgNLQ.CommentType).GENERAL,
                        parentCommentId: commentId
                    });
                    break;
                case 'commentUpdated':
                case 'avi:confluence:updated:comment':
                    if (commentId) {
                        const previousVersionNumber = (0, $b11gn.getCachedCommentVersionNumber)(commentId);
                        // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then((comment)=>{
                            return handleCompletePubSubExperiences([
                                {
                                    comment: comment,
                                    type: (0, $b11gn.CommentsPubsubTrackedEventType).Edit,
                                    previousVersionNumber: previousVersionNumber
                                }
                            ]);
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                    } else failCommentsPubSubExperience(new Error('commentUpdated: commentId is not defined'));
                    break;
                default:
                    failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                    break;
            }
        } catch (error) {
            failCommentsPubSubExperience(error);
            throw error;
        }
    };
const $ced40be9017d58cb$export$c542af303309df99 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, addSubscriber: addSubscriber, setContentType: setContentType, setContentId: setContentId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>{
    const pubSubResourceType = contentType || 'page';
    const subscriberIds = [];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentType || !setContentId) return;
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'pageCommentsPubSubCommentCreated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    addReplyToCommentThread: addReplyToCommentThread,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    addCommentInCache: addCommentInCache
                }),
                delta: 'commentCreated'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentResolved',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentResolved'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentDeleted',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    removeComment: removeComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    deleteCommentInCache: deleteCommentInCache,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentDeleted'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentReopened',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    reopenParentComment: reopenParentComment,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                }),
                delta: 'commentReopened'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentUpdated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    updateQueryVariables: {
                        contentId: contentId,
                        isReactionsEnabled: isReactionsEnabled
                    },
                    updateCommentBody: updateCommentBody
                }),
                delta: 'commentUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriberIds.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriberIds;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                addReplyToCommentThread: addReplyToCommentThread,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                addCommentInCache: addCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                removeComment: removeComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                deleteCommentInCache: deleteCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('reopen:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                reopenParentComment: reopenParentComment,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                updateQueryVariables: {
                    contentId: contentId,
                    isReactionsEnabled: isReactionsEnabled
                },
                updateCommentBody: updateCommentBody
            }));
        }).catch((error)=>{
            throw new Error(`Unable to joinChannel ${JSON.stringify(error)}`);
        });
    });
};
const $ced40be9017d58cb$export$f6e2e9a186163b28 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, removeSubscriber: removeSubscriber, subscriptions: subscriptions, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly })=>{
    const pubSubResourceType = contentType || 'page';
    const eventsToUnsubscribe = [
        'commentCreated',
        'commentDeleted',
        'commentUpdated'
    ];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning, confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!removeSubscriber || !subscriptions?.length) return;
        for (const subscriber of subscriptions)if (eventsToUnsubscribe.includes(subscriber.delta)) removeSubscriber(subscriber);
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            addNewComment: addNewComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            removeComment: removeComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            updateQueryVariables: {
                contentId: contentId,
                isReactionsEnabled: isReactionsEnabled
            },
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
    });
};
module.exports["setUpPageCommentsPubSub"] = $ced40be9017d58cb$export$c542af303309df99;
module.exports["removePageCommentsPubSub"] = $ced40be9017d58cb$export$f6e2e9a186163b28;

});

parcelRegister("aM1he", function(module, exports) {

var $kQekh = parcelRequire("kQekh");


var $c0rhi = parcelRequire("c0rhi");

const $406672c94379d4ab$export$5a1cd239009d83a6 = async (commentId, { contentId: contentId, isReactionsEnabled: isReactionsEnabled })=>{
    const query = isReactionsEnabled ? (0, $kQekh.CommentsSectionGetSingleCommentQuery) : (0, $kQekh.CommentsSectionGetSingleCommentWithoutReactionsQuery);
    const variables = isReactionsEnabled ? {
        commentId: commentId,
        contentId: contentId
    } : {
        commentId: commentId
    };
    // Query the single comment to update the cache
    (0, $c0rhi.queryInterop)({
        query: query,
        variables: variables,
        __callerPackage__: "comments-pubsub"
    });
};
const $406672c94379d4ab$export$af4b8274c1b86043 = (reloader, addNewComment, commentData, currentUserId)=>reloader().then(()=>{
        setTimeout(()=>{
            // HACK: Give the comments section time to render the new comment
            commentData.forEach((data)=>{
                addNewComment({
                    newCommentId: data.commentId,
                    currentUserMadeComment: data.accountId === currentUserId
                });
            });
        }, 3000);
    }).catch((err)=>{
        throw err;
    });
module.exports["reloadAndAddPageComments"] = $406672c94379d4ab$export$af4b8274c1b86043;

});

parcelRegister("kQekh", function(module, exports) {

var $k5aG8 = parcelRequire("k5aG8");


var $f9FCO = parcelRequire("f9FCO");

const $90ffe60e2eae60ca$export$bf87400a8da436f8 = (0, $f9FCO.default);
const $90ffe60e2eae60ca$export$caecd77287327384 = (0, $k5aG8.default);
module.exports["CommentsSectionGetSingleCommentQuery"] = $90ffe60e2eae60ca$export$bf87400a8da436f8;
module.exports["CommentsSectionGetSingleCommentWithoutReactionsQuery"] = $90ffe60e2eae60ca$export$caecd77287327384;

});

parcelRegister("k5aG8", function(module, exports) {
/**
 * @generated SignedSource<<8ed7915c440f335b6a58fb7784fdbb97>>
 * @relayHash d3bcc60b520b9e62b29ac8be494a67be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c
const $2711060718729916$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d3bcc60b520b9e62b29ac8be494a67be",
            "id": "7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQueryWithoutReactionsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$2711060718729916$var$node.hash = "2d393682eae4feef3986d5e4ea1bd5a6";
var $2711060718729916$export$2e2bcd8739ae039 = $2711060718729916$var$node;
module.exports["default"] = $2711060718729916$export$2e2bcd8739ae039;

});

parcelRegister("f9FCO", function(module, exports) {
/**
 * @generated SignedSource<<ba3d28415cb064032a9b12514118849b>>
 * @relayHash 1a3bffe088c5850ddf1b9c1ca4f044de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a
const $c1f0ddf438970e3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1a3bffe088c5850ddf1b9c1ca4f044de",
            "id": "99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$c1f0ddf438970e3e$var$node.hash = "326ee68c128aba1a564502e019c38ae6";
var $c1f0ddf438970e3e$export$2e2bcd8739ae039 = $c1f0ddf438970e3e$var$node;
module.exports["default"] = $c1f0ddf438970e3e$export$2e2bcd8739ae039;

});

parcelRegister("2xS8W", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $3mVfX = parcelRequire("3mVfX");


var $aHcFH = parcelRequire("aHcFH");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $fNzRA = parcelRequire("fNzRA");


var $ep3mz = parcelRequire("ep3mz");


var $jAfH5 = parcelRequire("jAfH5");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");


var $l1B53 = parcelRequire("l1B53");


var $dL5YQ = parcelRequire("dL5YQ");

const $e3138de675756a06$var$styles = {
    stickyDraftViewPageWrapper: "_1mT5xdHE3j _42Yu6B7dHp",
    stickyDraftLivePageWrapper: "_1mT5xdy1CL _42Yu6BN779",
    hiddenStyles: "_3iDTPbYbGa",
    visibleStyles: "_3iDTPbQ4SZ",
    commonStyle: "_0hPCNLDIqT _37wbyuDIqT _0Bm75GPgdg _0KLXrulfZc",
    childWrapperStyle: "_4FKVYE5zaO _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3vBAKH9r67 _22sfPnNvrM _2IVJ4M6wH8",
    zIndexStyle: "_42Yu6Bbhqd _3OE6xYPgdg _39xV02N91d"
};
const $e3138de675756a06$export$d2696a038fec0750 = (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { pageWidthType: pageWidthType } = t0;
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { expandCommentContainer: expandCommentContainer, setWrapperWidth: setWrapperWidth, setIsObjectCommentWrapperVisible: setIsObjectCommentWrapperVisible, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [objectCommentWrapperDimensions, setObjectCommentWrapperDimensions] = (0, $cozmU.useState)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isViewPage = pageMode === (0, $cD1qu.PageMode).VIEW;
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    let t1;
    let t2;
    if ($[0] !== expandCommentContainer || $[1] !== expanded || $[2] !== isObjectCommentWrapperVisible || $[3] !== setFooterEditorEntry) {
        t1 = ()=>{
            if (isObjectCommentWrapperVisible && expanded) {
                expandCommentContainer();
                setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
            }
        };
        t2 = [
            isObjectCommentWrapperVisible,
            expandCommentContainer,
            expanded,
            setFooterEditorEntry
        ];
        $[0] = expandCommentContainer;
        $[1] = expanded;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = setFooterEditorEntry;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== isViewPage || $[7] !== setIsObjectCommentWrapperVisible || $[8] !== setWrapperWidth) {
        t3 = ()=>{
            let intersectionObserver = null;
            let resizeObserver = null;
            let observedWrapper = null;
            const calculateObjectCommentWrapperWidth = ()=>{
                const objectCommentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (objectCommentWrapper) {
                    const rect = objectCommentWrapper.getBoundingClientRect();
                    setObjectCommentWrapperDimensions({
                        width: rect.width
                    });
                    setWrapperWidth(rect.width);
                }
            };
            const setupObservers = ()=>{
                const commentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (!commentWrapper) {
                    setIsObjectCommentWrapperVisible(false);
                    return;
                }
                if (observedWrapper && observedWrapper !== commentWrapper && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_footer_reactions_redesign", "isEnabled", true)) {
                    intersectionObserver?.disconnect();
                    resizeObserver?.disconnect();
                    intersectionObserver = null;
                    resizeObserver = null;
                }
                observedWrapper = commentWrapper;
                if (!intersectionObserver) {
                    intersectionObserver = new IntersectionObserver((t4)=>{
                        const [entry] = t4;
                        return setIsObjectCommentWrapperVisible(entry.isIntersecting);
                    }, {
                        rootMargin: "0px"
                    });
                    intersectionObserver.observe(commentWrapper);
                }
                if (!resizeObserver) {
                    resizeObserver = new ResizeObserver(calculateObjectCommentWrapperWidth);
                    resizeObserver.observe(commentWrapper);
                }
                calculateObjectCommentWrapperWidth();
            };
            setupObservers();
            const mutationObserver = new MutationObserver(()=>{
                const commentWrapper_0 = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (commentWrapper_0 && (!intersectionObserver || !isViewPage && !resizeObserver || commentWrapper_0 !== observedWrapper && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_footer_reactions_redesign", "isEnabled", true))) setupObservers();
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (intersectionObserver) intersectionObserver.disconnect();
                if (resizeObserver) resizeObserver.disconnect();
                mutationObserver.disconnect();
            };
        };
        $[6] = isViewPage;
        $[7] = setIsObjectCommentWrapperVisible;
        $[8] = setWrapperWidth;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== contentId || $[11] !== isViewPage || $[12] !== setIsObjectCommentWrapperVisible || $[13] !== setWrapperWidth) {
        t4 = [
            isViewPage,
            setWrapperWidth,
            setIsObjectCommentWrapperVisible,
            contentId
        ];
        $[10] = contentId;
        $[11] = isViewPage;
        $[12] = setIsObjectCommentWrapperVisible;
        $[13] = setWrapperWidth;
        $[14] = t4;
    } else t4 = $[14];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[15] !== pageContentLeft || $[16] !== pageContentRight || $[17] !== pageContentWidth) {
        t5 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[15] = pageContentLeft;
        $[16] = pageContentRight;
        $[17] = pageContentWidth;
        $[18] = t5;
    } else t5 = $[18];
    const pageContentDimensions = t5;
    let t6;
    if ($[19] !== hasRecs || $[20] !== isViewPage || $[21] !== objectCommentWrapperDimensions || $[22] !== pageMode || $[23] !== pageWidthType) {
        t6 = ()=>{
            if (isViewPage) {
                const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
                    pageMode: pageMode,
                    pageWidthType: pageWidthType,
                    hasEndOfPageRecommendations: hasRecs ?? false
                });
                return {
                    width: computedWidths.width,
                    maxWidth: computedWidths.maxWidth
                };
            }
            return {
                maxWidth: "100%",
                width: objectCommentWrapperDimensions ? `${objectCommentWrapperDimensions.width}px` : "100%"
            };
        };
        $[19] = hasRecs;
        $[20] = isViewPage;
        $[21] = objectCommentWrapperDimensions;
        $[22] = pageMode;
        $[23] = pageWidthType;
        $[24] = t6;
    } else t6 = $[24];
    const getStyle = t6;
    const showStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT;
    let t7;
    if ($[25] !== expandCommentContainer || $[26] !== setFooterEditorEntry) {
        t7 = ()=>{
            expandCommentContainer();
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT);
        };
        $[25] = expandCommentContainer;
        $[26] = setFooterEditorEntry;
        $[27] = t7;
    } else t7 = $[27];
    const expandEditorHandler = t7;
    if (!showStickyDraft) return;
    const t8 = isViewPage ? $e3138de675756a06$var$styles.stickyDraftViewPageWrapper : $e3138de675756a06$var$styles.stickyDraftLivePageWrapper;
    const t9 = showStickyDraft ? $e3138de675756a06$var$styles.visibleStyles : $e3138de675756a06$var$styles.hiddenStyles;
    const t10 = !isViewPage && $e3138de675756a06$var$styles.zIndexStyle;
    let t11;
    if ($[28] !== t10 || $[29] !== t8 || $[30] !== t9) {
        t11 = (0, $w6R6I.cx)(t8, t9, $e3138de675756a06$var$styles.commonStyle, t10);
        $[28] = t10;
        $[29] = t8;
        $[30] = t9;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== pageContentDimensions || $[33] !== pageMode) {
        t12 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: true,
            pageContentDimensions: pageContentDimensions
        }) : undefined;
        $[32] = pageContentDimensions;
        $[33] = pageMode;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== getStyle) {
        t13 = getStyle();
        $[35] = getStyle;
        $[36] = t13;
    } else t13 = $[36];
    const t14 = !showStickyDraft ? $e3138de675756a06$var$styles.hiddenStyles : $e3138de675756a06$var$styles.visibleStyles;
    let t15;
    if ($[37] !== t14) {
        t15 = (0, $w6R6I.cx)(t14);
        $[37] = t14;
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== expandEditorHandler) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1B53.DraftCommentBox), {
            expandPageCommentEditorHandler: expandEditorHandler
        });
        $[39] = expandEditorHandler;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== t15 || $[42] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t15
        }, t16)));
        $[41] = t15;
        $[42] = t16;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== t13 || $[45] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e3138de675756a06$var$styles.childWrapperStyle,
            style: t13
        }, t17);
        $[44] = t13;
        $[45] = t17;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== t11 || $[48] !== t12 || $[49] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t11,
            testId: "sticky-draft-comment-box",
            id: "addCommentButton-draft",
            style: t12
        }, t18);
        $[47] = t11;
        $[48] = t12;
        $[49] = t18;
        $[50] = t19;
    } else t19 = $[50];
    return t19;
};
module.exports["StickyDraftCommentContainer"] = $e3138de675756a06$export$d2696a038fec0750;

});

parcelRegister("jAfH5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");


var $2HQyh = parcelRequire("2HQyh");


var $8dbvt = parcelRequire("8dbvt");


var $jc6xl = parcelRequire("jc6xl");

const $7e53ce3ad8fd4fef$export$1d93f080b8c40251 = (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const skip = t0 === undefined ? false : t0;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const t1 = contentId ?? "";
    const t2 = contentType ?? "page";
    const t3 = spaceKey ?? "";
    let t4;
    if ($[0] !== skip) {
        t4 = skip || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_eop_recs_twg_source_exp", "isEnabled", true);
        $[0] = skip;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
        t5 = {
            entityId: t1,
            entityType: t2,
            spaceKey: t3,
            skip: t4
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const twg = (0, $jc6xl.useTwgRecommendationData)(t5);
    let t6;
    if ($[7] !== skip) {
        t6 = skip || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_eop_recs_twg_source_exp", "isEnabled", true);
        $[7] = skip;
        $[8] = t6;
    } else t6 = $[8];
    const smartsSkip = t6;
    const t7 = contentId ?? "";
    const t8 = spaceKey ?? "";
    const t9 = spaceKey ?? "";
    let t10;
    if ($[9] !== t7 || $[10] !== t8 || $[11] !== t9) {
        t10 = {
            type: "page",
            id: t7,
            exp: "end_of_page_v5",
            key: t8,
            keyString: t9
        };
        $[9] = t7;
        $[10] = t8;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            single: true
        };
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== smartsSkip || $[15] !== t10) {
        t12 = {
            variables: t10,
            context: t11,
            errorPolicy: "all",
            skip: smartsSkip
        };
        $[14] = smartsSkip;
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    const baseOptions = t12;
    const { error: smartsError, loading: smartsLoading, data: smartsData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "page-recommendations"
    });
    const t13 = smartsData?.getRecommendedPages?.recommendedPages;
    let t14;
    if ($[17] !== t13) {
        t14 = (0, $8dbvt.transformAndOrderRecs)(t13);
        $[17] = t13;
        $[18] = t14;
    } else t14 = $[18];
    const smartsPageCardData = t14;
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_eop_recs_twg_source_exp", "isEnabled", true)) {
        if (twg.error || skip) {
            let t15;
            if ($[19] !== twg.error) {
                t15 = {
                    loading: false,
                    error: twg.error,
                    data: undefined,
                    hasRecs: false
                };
                $[19] = twg.error;
                $[20] = t15;
            } else t15 = $[20];
            return t15;
        }
        const t15 = twg.isEnabled ? twg.pageCardData : undefined;
        const t16 = twg.isEnabled && twg.pageCardData.length > 2;
        let t17;
        if ($[21] !== t15 || $[22] !== t16 || $[23] !== twg.loading) {
            t17 = {
                loading: twg.loading,
                error: undefined,
                data: t15,
                hasRecs: t16
            };
            $[21] = t15;
            $[22] = t16;
            $[23] = twg.loading;
            $[24] = t17;
        } else t17 = $[24];
        return t17;
    }
    if (smartsError || skip) {
        let t15;
        if ($[25] !== smartsError) {
            t15 = {
                loading: false,
                error: smartsError,
                data: undefined,
                hasRecs: false
            };
            $[25] = smartsError;
            $[26] = t15;
        } else t15 = $[26];
        return t15;
    }
    const t15 = smartsPageCardData && smartsPageCardData.length > 2;
    let t16;
    if ($[27] !== smartsError || $[28] !== smartsLoading || $[29] !== smartsPageCardData || $[30] !== t15) {
        t16 = {
            loading: smartsLoading,
            error: smartsError,
            data: smartsPageCardData,
            hasRecs: t15
        };
        $[27] = smartsError;
        $[28] = smartsLoading;
        $[29] = smartsPageCardData;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    return t16;
};
module.exports["usePageRecommendationData"] = $7e53ce3ad8fd4fef$export$1d93f080b8c40251;

});

parcelRegister("aOKRX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k7Uqa = parcelRequire("k7Uqa");

const $b6b1455842ddb08b$export$d0606705f36ae70a = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [dimensions, setDimensions] = (0, $cozmU.useState)((0, $k7Uqa.EMPTY_PAGE_CONTENT_RECT));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const publish = (rect)=>setDimensions((current)=>(0, $k7Uqa.isSamePageContentRect)(current, rect) ? current : rect);
            publish((0, $k7Uqa.getPageContentRect)());
            return (0, $k7Uqa.subscribeToPageContentRect)(publish);
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return dimensions;
};
module.exports["usePageContentDimensions"] = $b6b1455842ddb08b$export$d0606705f36ae70a;

});

parcelRegister("niTts", function(module, exports) {
const $829c98791d74b4c3$export$a9fce9e535ae2163 = ({ shouldRenderFixedStyle: shouldRenderFixedStyle, pageContentDimensions: pageContentDimensions, fallbackWidth: fallbackWidth = '100%' })=>{
    if (!shouldRenderFixedStyle) return {
        width: fallbackWidth
    };
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = pageContentDimensions;
    // Handle case where dimensions might be undefined or width might be a string
    const width = typeof pageContentWidth === 'number' ? pageContentWidth : 0;
    const left = pageContentLeft ?? 0;
    const right = pageContentRight ?? 0;
    return {
        left: left > 0 ? `${left}px` : '0px',
        right: right > 0 ? `${window.innerWidth - right}px` : '0px',
        width: width > 0 ? `${width}px` : '100%'
    };
};
module.exports["hideWhiteSpace"] = $829c98791d74b4c3$export$a9fce9e535ae2163;

});

parcelRegister("l1B53", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hBYtq = parcelRequire("hBYtq");

const $656c656df397599d$var$styles = {
    draftComment: "_0bjKvDKxmn _4FKVYE2ADO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _0jFU0VnlTt _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _1UtDYzKGUX _0KLXru7Cj1"
};
const $656c656df397599d$var$i18n = (0, $kSwu1.defineMessages)({
    unsavedDraftComment: {
        id: "object-comments.draft-comment-box.text",
        defaultMessage: "Comment in progress - select to continue"
    }
});
const $656c656df397599d$export$82fe65228be9eec = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { testId: t1, expandPageCommentEditorHandler: expandPageCommentEditorHandler } = t0;
    const testId = t1 === undefined ? "draft-comment-box" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($656c656df397599d$var$i18n.unsavedDraftComment);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== expandPageCommentEditorHandler || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $656c656df397599d$var$styles.draftComment,
            testId: testId,
            onClick: expandPageCommentEditorHandler
        }, t2);
        $[2] = expandPageCommentEditorHandler;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["DraftCommentBox"] = $656c656df397599d$export$82fe65228be9eec;

});

parcelRegister("dL5YQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8lS8J = parcelRequire("8lS8J");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $fs6LW = parcelRequire("fs6LW");


var $bQm3c = parcelRequire("bQm3c");


var $1P7Cq = parcelRequire("1P7Cq");


var $90hCa = parcelRequire("90hCa");

const $f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery = (0, $8lS8J.default);
const $f361dd7d6e4d9bdd$var$styles = {
    addCommentWrapperStyles: "_39xV02N91d",
    addCommentWrapperWithBannerStyles: "_3iDTPbgBM8 _2iEGP2tJLP _17lj8p5zaO _39xV02N91d",
    addCommentOpenContainerStyles: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _0hPCNLchRC",
    addCommentOpenContainerWithBannerStyles: "_3iDTPbcK7c",
    addCommentEditorStyles: "_2j3gqAiZR3 _3B2K2QiZR3 _39xV02N91d _4ouGXIdnbC",
    bannerStyles: "_2j3gqAiZR3 _3B2K2Q7dHp _4ouGXIdnbC",
    avatarStyles: "_2j3gqA7dHp _3B2K2QiZR3 _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC"
};
const $f361dd7d6e4d9bdd$var$avatarFloatStyle = {
    float: 'left'
};
const $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8 = (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { children: children, banner: banner } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { currentUser: currentUser } = (0, $90hCa.useViewPageConversationData)();
    const t1 = userId || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            id: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = !userId || currentUser !== undefined;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            variables: t2,
            fetchPolicy: (0, $9wGTI.fg)("confluence-comments-fix-avatar-flash") ? "cache-first" : "cache-and-network",
            skip: t3
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: userData, loading: loading } = (0, $jMyy4.useQueryInterop)($f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery, {
        ...t4,
        __callerPackage__: "object-comments"
    });
    const user = currentUser === undefined ? userData?.user : currentUser;
    let t5;
    if ($[5] !== currentUser?.photos || $[6] !== user?.photos?.[0]) {
        t5 = currentUser?.photos?.find($f361dd7d6e4d9bdd$var$_temp) ?? user?.photos?.[0];
        $[5] = currentUser?.photos;
        $[6] = user?.photos?.[0];
        $[7] = t5;
    } else t5 = $[7];
    const primaryPhoto = t5;
    const t6 = primaryPhoto?.value || "";
    const t7 = currentUser?.id ?? userId;
    const t8 = user?.displayName || "";
    let t9;
    if ($[8] !== t6 || $[9] !== t7 || $[10] !== t8) {
        t9 = {
            avatarUrl: t6,
            accountId: t7,
            displayName: t8
        };
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    const userInfo = t9;
    const t10 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentWrapperWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentWrapperStyles;
    let t11;
    if ($[12] !== banner) {
        t11 = banner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.bannerStyles
        }, banner) : null;
        $[12] = banner;
        $[13] = t11;
    } else t11 = $[13];
    const t12 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerStyles;
    let t13;
    if ($[14] !== currentUser || $[15] !== loading || $[16] !== renderServerPlaceholder || $[17] !== userInfo) {
        t13 = currentUser === undefined && loading || renderServerPlaceholder ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
            canViewProfile: true,
            src: userInfo.avatarUrl,
            userId: userInfo.accountId,
            isAnonymous: !userInfo.accountId,
            name: userInfo.displayName,
            testId: "profile-avatar-comment"
        });
        $[14] = currentUser;
        $[15] = loading;
        $[16] = renderServerPlaceholder;
        $[17] = userInfo;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.avatarStyles,
            style: $f361dd7d6e4d9bdd$var$avatarFloatStyle
        }, t13);
        $[19] = t13;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== children) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.addCommentEditorStyles
        }, children);
        $[21] = children;
        $[22] = t15;
    } else t15 = $[22];
    let t16;
    if ($[23] !== t12 || $[24] !== t14 || $[25] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t12
        }, t14, t15);
        $[23] = t12;
        $[24] = t14;
        $[25] = t15;
        $[26] = t16;
    } else t16 = $[26];
    let t17;
    if ($[27] !== t10 || $[28] !== t11 || $[29] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t10
        }, t11, t16);
        $[27] = t10;
        $[28] = t11;
        $[29] = t16;
        $[30] = t17;
    } else t17 = $[30];
    return t17;
};
const $f361dd7d6e4d9bdd$export$42643a55112a17f5 = ()=>{
    const $ = (0, $bDgLe.c)(14);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { currentUser: currentUser } = (0, $90hCa.useViewPageConversationData)();
    const t0 = userId || "";
    let t1;
    if ($[0] !== t0) {
        t1 = {
            id: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !userId || currentUser !== undefined;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            fetchPolicy: (0, $9wGTI.fg)("confluence-comments-fix-avatar-flash") ? "cache-first" : "cache-and-network",
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: userData, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery, {
        ...t3,
        __callerPackage__: "object-comments"
    });
    const user = currentUser === undefined ? userData?.user : currentUser;
    let t4;
    if ($[5] !== currentUser?.photos || $[6] !== user?.photos?.[0]) {
        t4 = currentUser?.photos?.find($f361dd7d6e4d9bdd$var$_temp2) ?? user?.photos?.[0];
        $[5] = currentUser?.photos;
        $[6] = user?.photos?.[0];
        $[7] = t4;
    } else t4 = $[7];
    const primaryPhoto = t4;
    const t5 = primaryPhoto?.value || "";
    const t6 = currentUser?.id ?? userId;
    const t7 = user?.displayName || "";
    const t8 = currentUser === undefined && loading;
    const t9 = currentUser === undefined ? error : undefined;
    let t10;
    if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
        t10 = {
            avatarUrl: t5,
            accountId: t6,
            displayName: t7,
            loading: t8,
            error: t9
        };
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
        $[11] = t8;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
function $f361dd7d6e4d9bdd$var$_temp(photo) {
    return photo?.isPrimary;
}
function $f361dd7d6e4d9bdd$var$_temp2(photo) {
    return photo?.isPrimary;
}
module.exports["ObjectAddCommentProfileWrapper"] = $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8;
module.exports["useCommentAuthorInfo"] = $f361dd7d6e4d9bdd$export$42643a55112a17f5;

});

parcelRegister("8lS8J", function(module, exports) {
/**
 * @generated SignedSource<<41cbeaa06d5991b406f8cd5c92a2f482>>
 * @relayHash 0725da37403499b17b096784b15edae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1
const $a4f88c0b86e6c5fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0725da37403499b17b096784b15edae6",
            "id": "a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1",
            "metadata": {},
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "operationKind": "query",
            "text": "query ObjectAddCommentProfileWrapperUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4f88c0b86e6c5fb$var$node.hash = "d4c2e7d15525539be1b21ee5306d9088";
var $a4f88c0b86e6c5fb$export$2e2bcd8739ae039 = $a4f88c0b86e6c5fb$var$node;
module.exports["default"] = $a4f88c0b86e6c5fb$export$2e2bcd8739ae039;

});

parcelRegister("90hCa", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $Y7c12 = parcelRequire("Y7c12");

const $63b79909c334e6ed$var$ViewPageConversationDataContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $63b79909c334e6ed$export$6b7319349c5ed6e5 = ()=>{
    return (0, $cozmU.useContext)($63b79909c334e6ed$var$ViewPageConversationDataContext);
};
const $63b79909c334e6ed$export$f71f330d60e65f82 = (commentThreadsFragmentRef)=>{
    return (0, $6SsN4.useFragment)((0, $Y7c12.ViewPageConversationCommentThreadsFragment), commentThreadsFragmentRef);
};
const $63b79909c334e6ed$export$290a16f5398a1562 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentPermissionFragmentRef: contentPermissionFragmentRef, currentUserFragmentRef: currentUserFragmentRef, children: children } = t0;
    const contentPermission = (0, $6SsN4.useFragment)((0, $Y7c12.ViewPageConversationContentPermissionFragment), contentPermissionFragmentRef);
    const currentUserData = (0, $6SsN4.useFragment)((0, $Y7c12.ViewPageConversationCurrentUserFragment), currentUserFragmentRef);
    const operations = contentPermission?.operations;
    const currentUser = currentUserData?.user;
    let t1;
    if ($[0] !== operations) {
        t1 = operations === undefined ? undefined : (operations ?? []).some($63b79909c334e6ed$var$_temp);
        $[0] = operations;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== currentUser || $[3] !== t1) {
        t2 = {
            canAddComments: t1,
            currentUser: currentUser
        };
        $[2] = currentUser;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const value = t2;
    let t3;
    if ($[5] !== children || $[6] !== value) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63b79909c334e6ed$var$ViewPageConversationDataContext.Provider, {
            value: value
        }, children);
        $[5] = children;
        $[6] = value;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
function $63b79909c334e6ed$var$_temp(operation) {
    return operation?.operation === "create" && operation.targetType === "comment";
}
module.exports["useViewPageConversationData"] = $63b79909c334e6ed$export$6b7319349c5ed6e5;
module.exports["useViewPageConversationCommentThreads"] = $63b79909c334e6ed$export$f71f330d60e65f82;
module.exports["ViewPageConversationDataProvider"] = $63b79909c334e6ed$export$290a16f5398a1562;

});

parcelRegister("Y7c12", function(module, exports) {

var $kltGP = parcelRequire("kltGP");


var $35eA2 = parcelRequire("35eA2");


var $g29wT = parcelRequire("g29wT");


var $aPMMk = parcelRequire("aPMMk");


var $kBu9e = parcelRequire("kBu9e");


var $188lF = parcelRequire("188lF");

const $8509c3b60aeecfdb$export$36e6a704a4f7a532 = (0, $188lF.default);
const $8509c3b60aeecfdb$export$3b05231a4b229ffc = (0, $kBu9e.default);
const $8509c3b60aeecfdb$export$3afa00e311ca0267 = (0, $aPMMk.default);
const $8509c3b60aeecfdb$export$f31afb6c0b1f4a81 = (0, $g29wT.default);
const $8509c3b60aeecfdb$export$dc0c5432e58ff8cd = (0, $35eA2.default);
const $8509c3b60aeecfdb$export$eb2938203e9337 = (0, $kltGP.default);
module.exports["ViewPageConversationContentPermissionFragment"] = $8509c3b60aeecfdb$export$36e6a704a4f7a532;
module.exports["ViewPageConversationCurrentUserFragment"] = $8509c3b60aeecfdb$export$3b05231a4b229ffc;
module.exports["ViewPageConversationCommentThreadsFragment"] = $8509c3b60aeecfdb$export$eb2938203e9337;

});

parcelRegister("kltGP", function(module, exports) {
/**
 * @generated SignedSource<<4115eb1bbbe74d0d1d40b35a12feff03>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bdfb60340cebafa5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v4 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v10 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v11 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v8 /*: any*/ 
    }, v12 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "condition": "includeCommentReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "number"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "includeCommentReactions"
            },
            {
                "kind": "RootArgument",
                "name": "pageId"
            }
        ],
        "kind": "Fragment",
        "name": "ViewPageConversation_commentThreads",
        "selections": [
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            v5 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    v7 /*: any*/ ,
                    v9 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "container",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    },
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "replies",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v4 /*: any*/ 
                                ]
                            },
                            v9 /*: any*/ ,
                            v10 /*: any*/ ,
                            v11 /*: any*/ ,
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "by",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ]
                                    },
                                    v22 /*: any*/ ,
                                    v23 /*: any*/ 
                                ]
                            },
                            v7 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "friendlyWhen"
                            },
                            v22 /*: any*/ ,
                            v23 /*: any*/ 
                        ]
                    },
                    v21 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            v1 /*: any*/ 
        ],
        "type": "PaginatedCommentList"
    };
}();
$bdfb60340cebafa5$var$node.hash = "ecfa893429b4a9b3c0bc6291778fd2f1";
var $bdfb60340cebafa5$export$2e2bcd8739ae039 = $bdfb60340cebafa5$var$node;
module.exports["default"] = $bdfb60340cebafa5$export$2e2bcd8739ae039;

});

parcelRegister("35eA2", function(module, exports) {
/**
 * @generated SignedSource<<d592ec00e1bb9d55e8667521a254025a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9c594c9f04365af5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v4 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v10 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v11 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v8 /*: any*/ 
    }, v12 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "condition": "includeCommentReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "number"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "includeCommentReactions"
            },
            {
                "kind": "RootArgument",
                "name": "pageId"
            }
        ],
        "kind": "Fragment",
        "name": "ViewPageConversation_commentThread",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v7 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v22 /*: any*/ ,
                            v23 /*: any*/ 
                        ]
                    },
                    v7 /*: any*/ 
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v22 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            },
            v21 /*: any*/ 
        ],
        "type": "Comment"
    };
}();
$9c594c9f04365af5$var$node.hash = "60bda14127b38a990b0614c09aa009d2";
var $9c594c9f04365af5$export$2e2bcd8739ae039 = $9c594c9f04365af5$var$node;
module.exports["default"] = $9c594c9f04365af5$export$2e2bcd8739ae039;

});

parcelRegister("g29wT", function(module, exports) {
/**
 * @generated SignedSource<<1260ac90fc9b4f041697122825c5248f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95960d49dde769a0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v5 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v7 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "includeCommentReactions"
            },
            {
                "kind": "RootArgument",
                "name": "pageId"
            }
        ],
        "kind": "Fragment",
        "name": "ViewPageConversation_reply",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ],
                        "type": "KnownUser"
                    },
                    {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "path"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "representation",
                        "value": "ATLAS_DOC_FORMAT"
                    }
                ],
                "concreteType": "DocumentBody",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdAt",
                "plural": false,
                "selections": v3 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "createdAtNonLocalized"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "commentResolveProperties",
                                "plural": false,
                                "selections": [
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "FooterComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "inlineMarkerRef"
                            },
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "inlineResolveProperties",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDangling"
                                    },
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "inlineText"
                            }
                        ],
                        "type": "InlineComment"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "parentId"
            },
            {
                "concreteType": "CommentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRemovable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isResolvable"
                    }
                ]
            },
            {
                "condition": "includeCommentReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "childType",
                                "value": "comment"
                            },
                            {
                                "kind": "Literal",
                                "name": "contentType",
                                "value": "page"
                            },
                            {
                                "kind": "Variable",
                                "name": "pageId",
                                "variableName": "pageId"
                            }
                        ],
                        "concreteType": "ReactionsSummaryResponse",
                        "kind": "LinkedField",
                        "name": "reactionsSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "ari"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "containerAri"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reactionsCount"
                            },
                            {
                                "concreteType": "ReactionsSummaryForEmoji",
                                "kind": "LinkedField",
                                "name": "reactionsSummaryForEmoji",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "count"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "emojiId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "reacted"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$95960d49dde769a0$var$node.hash = "0aca614e22f27edd22ee13f62fdc88d1";
var $95960d49dde769a0$export$2e2bcd8739ae039 = $95960d49dde769a0$var$node;
module.exports["default"] = $95960d49dde769a0$export$2e2bcd8739ae039;

});

parcelRegister("aPMMk", function(module, exports) {
/**
 * @generated SignedSource<<b3ec4d23a6b8e51b54e9585601950641>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $834227229d3e433f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "includeCommentReactions"
        },
        {
            "kind": "RootArgument",
            "name": "pageId"
        }
    ],
    "kind": "Fragment",
    "name": "ViewPageConversation_commentReactions",
    "selections": [
        {
            "condition": "includeCommentReactions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "childType",
                            "value": "comment"
                        },
                        {
                            "kind": "Literal",
                            "name": "contentType",
                            "value": "page"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ReactionsSummaryResponse",
                    "kind": "LinkedField",
                    "name": "reactionsSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "containerAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "concreteType": "ReactionsSummaryForEmoji",
                            "kind": "LinkedField",
                            "name": "reactionsSummaryForEmoji",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "emojiId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reacted"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Comment"
};
$834227229d3e433f$var$node.hash = "8c6509fad2ffae7fb1de4666394465d8";
var $834227229d3e433f$export$2e2bcd8739ae039 = $834227229d3e433f$var$node;
module.exports["default"] = $834227229d3e433f$export$2e2bcd8739ae039;

});

parcelRegister("kBu9e", function(module, exports) {
/**
 * @generated SignedSource<<b2dd760c5965642029ad8dc86399ae00>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $00f48df8c1aa23a4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ViewPageConversation_currentUser",
    "selections": [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ],
    "type": "Query"
};
$00f48df8c1aa23a4$var$node.hash = "827270ef4e156b471f2ba4f85ce30b66";
var $00f48df8c1aa23a4$export$2e2bcd8739ae039 = $00f48df8c1aa23a4$var$node;
module.exports["default"] = $00f48df8c1aa23a4$export$2e2bcd8739ae039;

});

parcelRegister("188lF", function(module, exports) {
/**
 * @generated SignedSource<<bcf2006f5aa77d4ebd6287d18b375421>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0a3cb416ec9ba59f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ViewPageConversation_contentPermission",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            v1 /*: any*/ ,
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                    }
                                ],
                                "type": "KnownUser"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$0a3cb416ec9ba59f$var$node.hash = "b8fd3a65641d68f4e8370ccd26921c25";
var $0a3cb416ec9ba59f$export$2e2bcd8739ae039 = $0a3cb416ec9ba59f$var$node;
module.exports["default"] = $0a3cb416ec9ba59f$export$2e2bcd8739ae039;

});

parcelRegister("70pcM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $deTj5 = parcelRequire("deTj5");


var $3mVfX = parcelRequire("3mVfX");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $8zMP3 = parcelRequire("8zMP3");


var $1xpoY = parcelRequire("1xpoY");


const $21986f05fdcd4f3c$var$ObjectCommentContainerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zDMTR",
    name: "ObjectCommentContainerLoader",
    loader: async ()=>(await (parcelRequire("jMvBA"))).ObjectCommentContainer
});
const $21986f05fdcd4f3c$export$5a58d81bd405c4ec = ({ pageWidthType: pageWidthType, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline, hasCommentSessions: hasCommentSessions })=>{
    const { setShowGeneralComments: setShowGeneralComments } = (0, $3mVfX.useCommentsPanelActions)();
    (0, $cozmU.useEffect)(()=>{
        setShowGeneralComments(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
    }, []);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21986f05fdcd4f3c$var$ObjectCommentContainerLoader, {
        pageWidthType: pageWidthType,
        showLabels: showLabels,
        hasReactions: hasReactions,
        editorIsUserOffline: editorIsUserOffline,
        hasCommentSessions: hasCommentSessions
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "object-comments"
    }, !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_comment_threads_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deTj5.CommentPlaceholder), {
            showPlaceholder: true
        })
    }, content) : content);
};
module.exports["ObjectCommentWrapper"] = $21986f05fdcd4f3c$export$5a58d81bd405c4ec;

});

parcelRegister("deTj5", function(module, exports) {
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1bHrqEN91d _1DCdHi2ADO",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2 _39xV02Uofl _0jFU0VUofl _3138421Y8M _0adFHs8HPE",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1x1D3gOeNX _4f9mo4J5bs _3iDTPbvLZJ _1DCdHi5zaO _0Of8r28HPE _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $buxP3.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _0bjKvDzXzM _39xV02N91d _0jFU0VUF4f _1UtDYzKGUX _0Of8r2Pgdg _3iDTPbvbI6 _1RrJLiBwqQ _2XsHFM2ADO _2O5Vij7dHp _0KLXruGsB2",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbgBM8 _2iEGP2stRB _0sTzLkuFDC _0KLXrujOvk _39xV024DOi _2XsHFM2ADO",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1xC2CJN5x9 _4FKVYEYopn _30huDKYbGa _0bjKvDzXzM _0KLXruGsB2 _2fwxA5DIqT",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1xC2CJcO1q _4FKVYEo5Kj _30huDKYbGa _0bjKvDzXzM _0KLXruGsB2 _2fwxA5DIqT",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (window.__SSR_RENDERED__ || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};
module.exports["CommentPlaceholder"] = $c27f350b69a05b43$export$46096a93b7c122b2;

});

parcelRegister("jMvBA", function(module, exports) {

let $e66b042a0a4777c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e66b042a0a4777c5$var$load("6oQJa"),
    $e66b042a0a4777c5$var$load("5b77R"),
    $e66b042a0a4777c5$var$load("cZjWF"),
    $e66b042a0a4777c5$var$load("lIK0s"),
    $e66b042a0a4777c5$var$load("6wr18"),
    $e66b042a0a4777c5$var$load("dlm6q"),
    $e66b042a0a4777c5$var$load("fxlto"),
    $e66b042a0a4777c5$var$load("lK9vp"),
    $e66b042a0a4777c5$var$load("50xKF"),
    $e66b042a0a4777c5$var$load("2bOpC"),
    $e66b042a0a4777c5$var$load("aIw3f"),
    $e66b042a0a4777c5$var$load("bY2TC"),
    $e66b042a0a4777c5$var$load("49tzV"),
    $e66b042a0a4777c5$var$load("gAKfH"),
    $e66b042a0a4777c5$var$load("Wowvf"),
    $e66b042a0a4777c5$var$load("7EorR"),
    $e66b042a0a4777c5$var$load("eUsnQ"),
    $e66b042a0a4777c5$var$load("ffEVr"),
    $e66b042a0a4777c5$var$load("8bEF3"),
    $e66b042a0a4777c5$var$load("ckVWI"),
    $e66b042a0a4777c5$var$load("fWCBZ"),
    $e66b042a0a4777c5$var$load("9xsUR"),
    $e66b042a0a4777c5$var$load("fk2KD"),
    $e66b042a0a4777c5$var$load("01KnF")
]).then(()=>parcelRequire('5CNGn'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("hdxAi", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2d2e882c9a90b3be$var$getInitialState = ()=>({
        deletedMentions: [],
        addedMentions: [],
        deletedTasks: [],
        addedTasks: [],
        unrestrictedMentions: [],
        //Added mentions which have access to the current page
        parentSpaceRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to page restrictions
        unrestrictedTasks: [],
        //Added task mentions which have access to the current page
        parentSpaceRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to page restrictions
        editorApi: undefined,
        mentionsAdded: {
            currentUser: [],
            //Mentions of current user added by the current user
            otherUsers: [] //Mentions of other users added by the current user
        },
        tasksAdded: {
            currentUser: [],
            //Task mentions of current user added by the current user
            otherUsers: [] //Task mentions of other users added by the current user
        }
    });
const $2d2e882c9a90b3be$var$actions = {
    setDeletedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                deletedMentions: mentions
            });
        },
    setAddedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                addedMentions: mentions
            });
        },
    setUnrestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                unrestrictedMentions: mentions
            });
        },
    addUnrestrictedMentions: (addedUnrestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = [
                ...unrestrictedMentions,
                ...addedUnrestrictedMentions
            ];
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    removeUnrestrictedMentions: (removedUnrestrictedMention)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedMention.map((mention)=>mention.localId));
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = unrestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    setParentSpaceRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedMentions: mentions
            });
        },
    addParentSpaceRestrictedMentions: (addedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = [
                ...parentSpaceRestrictedMentions,
                ...addedParentSpaceRestrictedMentions
            ];
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    removeParentSpaceRestrictedMentions: (removedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedMentions.map((mention)=>mention.localId));
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = parentSpaceRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    setPageRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                pageRestrictedMentions: mentions
            });
        },
    addPageRestrictedMentions: (addedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = [
                ...pageRestrictedMentions,
                ...addedPageRestrictedMentions
            ];
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    removePageRestrictedMentions: (removedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedMentions.map((mention)=>mention.localId));
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = pageRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    setDeletedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                deletedTasks: tasks
            });
        },
    setAddedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                addedTasks: tasks
            });
        },
    setPageRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                pageRestrictedTasks: tasks
            });
        },
    addPageRestrictedTasks: (addedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = [
                ...pageRestrictedTasks,
                ...addedPageRestrictedTasks
            ];
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    removePageRestrictedTasks: (removedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedTasks.map((tasks)=>tasks.localId));
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = pageRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    setParentSpaceRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedTasks: tasks
            });
        },
    addParentSpaceRestrictedTasks: (addedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = [
                ...parentSpaceRestrictedTasks,
                ...addedParentSpaceRestrictedTasks
            ];
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    removeParentSpaceRestrictedTasks: (removedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedTasks.map((tasks)=>tasks.localId));
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    setUnrestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                unrestrictedTasks: tasks
            });
        },
    addUnrestrictedTasks: (addedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = [
                ...unrestrictedTasks,
                ...addedUnrestrictedTasks
            ];
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    removeUnrestrictedTasks: (removedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedTasks.map((tasks)=>tasks.localId));
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = unrestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    setMentionsAdded: (mentionsToAdd)=>({ setState: setState, getState: getState })=>{
            const { mentionsAdded: mentionsAdded } = getState();
            const updatedMentionsAdded = mentionsAdded;
            if (mentionsToAdd.currentUser) {
                if (mentionsToAdd.currentUser.length > 0) {
                    const currentUserMentions = mentionsToAdd.currentUser;
                    updatedMentionsAdded.currentUser = [
                        ...currentUserMentions,
                        ...mentionsAdded.currentUser
                    ];
                } else updatedMentionsAdded.currentUser = [];
            }
            setState({
                mentionsAdded: updatedMentionsAdded
            });
        },
    setTasksAdded: (tasksToAdd)=>({ setState: setState, getState: getState })=>{
            const { tasksAdded: tasksAdded } = getState();
            const updatedTasksAdded = tasksAdded;
            if (tasksToAdd.currentUser) {
                if (tasksToAdd.currentUser.length > 0) {
                    const currentUserTasks = tasksToAdd.currentUser;
                    updatedTasksAdded.currentUser = [
                        ...currentUserTasks,
                        ...tasksAdded.currentUser
                    ];
                } else updatedTasksAdded.currentUser = [];
            }
            setState({
                tasksAdded: updatedTasksAdded
            });
        },
    clearMentionsFlags: ()=>({ setState: setState })=>{
            setState($2d2e882c9a90b3be$var$getInitialState());
        }
};
const $2d2e882c9a90b3be$var$MentionsNotificationsStore = (0, $8s9DV.createStore)({
    initialState: $2d2e882c9a90b3be$var$getInitialState(),
    actions: $2d2e882c9a90b3be$var$actions,
    name: 'MentionsNotificationsStore'
});
const $2d2e882c9a90b3be$export$63a7b4a5d3248013 = (0, $kBr4q.createHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
const $2d2e882c9a90b3be$export$e03e9325d0a65293 = (0, $kBr4q.createActionsHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
module.exports["useMentionsNotifications"] = $2d2e882c9a90b3be$export$63a7b4a5d3248013;
module.exports["useMentionsNotificationsActions"] = $2d2e882c9a90b3be$export$e03e9325d0a65293;

});

parcelRegister("cmBjr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bqMNb = parcelRequire("bqMNb");


var $jv3O2 = parcelRequire("jv3O2");


var $i9VoI = parcelRequire("i9VoI");

const $1c71f3d63aae3f56$export$b0544c15da22323d = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSubscriptionEvent = (0, $cozmU.useCallback)((response)=>{
        const { accountId: accountId, pageUpdated: pageUpdated } = response || {};
        const trigger = pageUpdated?.trigger;
        if (trigger !== 'convertToLiveEdit') return;
        showConvertToLivePageFlag({
            converterWasCurrentUser: accountId === userId
        });
        // When another user converts the page to a live doc, we need to add a query param to avoid the double action bar bug.
        // Without this, the page may read stale SSR values indicating it's not a live page, causing UI weirdness.
        // The query param forces RouteState to increment transitionId, preventing it from using initial SSR values.
        setQueryParams({
            [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        });
    }, [
        showConvertToLivePageFlag,
        userId,
        setQueryParams
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'convertToLivePageFlag',
        contentId: contentId,
        delta: 'pageUpdated',
        contentType: 'page',
        skip: !contentId,
        onDataReceived: (response)=>onSubscriptionEvent(response)
    });
    return null;
});
module.exports["ConvertToLivePageFlag"] = $1c71f3d63aae3f56$export$b0544c15da22323d;

});

parcelRegister("fzhfU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $JTIzG = parcelRequire("JTIzG");

const $e4992c54b0e0da53$export$ede5d3bbbf3ec238 = (0, $3u0dr.isReactCompilerActiveV2)() ? (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && !isAudioBylineEntrypointEnabled;
} : (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    // Only show audio entrypoint in sidebar if:
    // 1. AI is Enabled for content
    // 2. AI Policy and browser support are enabled AND
    // 3. The when byline entrypoint is not enabled (ex: Audio V2 experience), the object sidebar will be the only audio entrypoint.
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && !isAudioBylineEntrypointEnabled;
};
module.exports["useHasAudioButton"] = $e4992c54b0e0da53$export$ede5d3bbbf3ec238;

});


//# sourceMappingURL=ViewPage.6df75db3.js.map
